import { render, staticRenderFns } from "./HomeRecommendWrap.vue?vue&type=template&id=34ec60b3&"
import script from "./HomeRecommendWrap.vue?vue&type=script&lang=js&"
export * from "./HomeRecommendWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports